export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8595.74c29fb6.jpg";